const HiddenField = ({ name, inputValue, inputId ,validation}) => {
    return (
      <>
        <input type="hidden" name={name} id={inputId} value={inputValue} ref={validation}/>
      </>
    );
  };
  export default HiddenField;